{
  "videos": [
    {
      "slug": "what-is-ai",
      "title": "What is AI, really?",
      "description": "A one-minute explanation of how large language models learn patterns, write answers one piece at a time, and where they fall short.",
      "duration": 61.6,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/what-is-ai/161a6e2720a9/what-is-ai.mp4",
      "poster": "https://cdn.gab.ai/tutorials/what-is-ai/a81ab464401c/what-is-ai-poster.jpg",
      "captions": "/tutorials/captions/what-is-ai.en.vtt",
      "learn": [
        "what-is-ai"
      ],
      "docs": [],
      "cta": {
        "start": 54.97,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "When people say AI today, they usually mean a large language model. Here's what that actually is, in about a minute. A language model has read a huge amount of human writing: books, articles, conversations, and code. From all of it, it learned patterns in how words and ideas fit together. When you ask a question, it writes the answer one small piece at a time. Each time, it predicts what should come next. That's why a vague prompt gets a vague answer. Give it a specific job, an audience, and a format, and it has something worth completing. It isn't a search engine, and it isn't a mind. It can sound confident and still be wrong, so check the facts that matter. Now you know what AI is, and why a clear prompt makes all the difference."
    },
    {
      "slug": "meet-gab-ai",
      "title": "AI that works.",
      "description": "A fast tour of Gab AI: nearly 200 models on one account, the Work agent for whole projects, video, games, images, music, bots, and more time for living.",
      "duration": 45.5,
      "uploadDate": "2026-09-28",
      "src": "https://cdn.gab.ai/tutorials/meet-gab-ai/d9a217776fd8/meet-gab-ai.mp4",
      "poster": "https://cdn.gab.ai/tutorials/meet-gab-ai/db725bb8e448/meet-gab-ai-poster.jpg",
      "captions": "/tutorials/captions/meet-gab-ai.en.vtt",
      "learn": [],
      "docs": [],
      "pages": [
        "home"
      ],
      "cta": {
        "start": 43.28,
        "label": "Sign up for free",
        "action": "app",
        "left": 41.08,
        "top": 54.58,
        "width": 17.84,
        "height": 8.89
      },
      "transcript": "This is Gab AI. AI that actually works. Chat with GPT, Claude, Gemini, and nearly two hundred models, all on one account. Need more than an answer? Hand the whole job to Work. It plans it, builds it, and checks it. Websites. Documents. Presentations. Spreadsheets. Code. Direct a video shot by shot. Build a game you can play. Edit any image. Make a song. Build an AI team that works your way. Voice chats. Scheduled tasks. Memory you control. One subscription, on the web, your phone, and your Mac. So you get more time for living. Try Gab AI free."
    },
    {
      "slug": "about-gab-ai",
      "title": "More time for the people you love.",
      "description": "Why we build Gab AI: AI that does more of the work, so people become more productive, more prosperous, and more present with the people they love.",
      "duration": 69.7,
      "uploadDate": "2026-09-28",
      "src": "https://cdn.gab.ai/tutorials/about-gab-ai/e8a5290c274c/about-gab-ai.mp4",
      "poster": "https://cdn.gab.ai/tutorials/about-gab-ai/ac8f8a3804b1/about-gab-ai-poster.jpg",
      "captions": "/tutorials/captions/about-gab-ai.en.vtt",
      "learn": [],
      "docs": [],
      "pages": [
        "about"
      ],
      "cta": {
        "start": 62.94,
        "label": "See what you can make",
        "action": "app",
        "left": 38.2,
        "top": 54.58,
        "width": 23.6,
        "height": 8.89
      },
      "transcript": "We don't have to choose between getting ahead at work and getting home. We started Gab AI with a conviction: AI should help people become more capable, and give them time back for living. So we bring leading models into one place, and give them the tools to do useful work: research a subject, make a film, prepare a presentation, or turn an idea into working software. As AI does more of the work automatically, we become more productive, more prosperous, and more present. AI should leave room for independent thought, respect the people using it, and give them control. That means free expression, control over your data, and the freedom to choose. Our measure of progress is what you can accomplish with it, and what you do with the time you get back. More time for the things you love, with the people you love. We're an independent American company building that future. See what you can make."
    },
    {
      "slug": "learn-intro",
      "title": "Learn to use AI, one short lesson at a time",
      "description": "A quick tour of Gab AI and how the Learn lessons work: short reads, videos, and practice prompts you can try yourself.",
      "duration": 51.9,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/learn-intro/7e66b257eb83/learn-intro.mp4",
      "poster": "https://cdn.gab.ai/tutorials/learn-intro/da11ab014236/learn-intro-poster.jpg",
      "captions": "/tutorials/captions/learn-intro.en.vtt",
      "learn": [
        "index"
      ],
      "docs": [],
      "cta": {
        "start": 47.69,
        "label": "Pick your first lesson",
        "action": "lessons",
        "left": 39.2,
        "top": 54.58,
        "width": 21.59,
        "height": 8.89
      },
      "transcript": "Welcome to Gab AI Learn: short, practical lessons that teach you how to use AI for everyday work. Gab AI brings it all into one place. Chat and research with sources, create images and videos, explore maps, build your own agents, and schedule tasks that run for you. The lessons are organized into modules. Start with the basics and better prompts, then move on to creating, power features, and projects in Work. Each lesson takes just a few minutes. Read the skill, watch a short video, then try it yourself with a practice prompt. You don't need any experience. The lessons are free, and you can go at your own pace. Pick your first lesson, and start learning."
    },
    {
      "slug": "gab-ai-for-mac",
      "title": "Gab AI for Mac",
      "description": "What the Gab AI Mac app adds: project folders, browser and app access, review and restore, and native menus and shortcuts.",
      "duration": 71.4,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/gab-ai-for-mac/f6ab530d69c2/gab-ai-for-mac.mp4",
      "poster": "https://cdn.gab.ai/tutorials/gab-ai-for-mac/dd78cb62084e/gab-ai-for-mac-poster.jpg",
      "captions": "/tutorials/captions/gab-ai-for-mac.en.vtt",
      "learn": [],
      "docs": [
        "mac-app"
      ],
      "cta": {
        "start": 66.29,
        "label": "Download for Mac",
        "action": "link",
        "href": "/mac",
        "left": 40.07,
        "top": 54.58,
        "width": 19.87,
        "height": 8.89
      },
      "transcript": "Gab AI for Mac brings Chat, AI models, Bots, media tools, and Work into a native app, with Work able to use the files and apps you choose. Download it from gab.ai slash mac and sign in with your Gab AI account. Your conversations, plan, and credits come with you. The local features in this video need that direct-download edition. Work can use a project folder on your Mac. Choose a folder, describe the result, and review what comes back. The finished files are saved right where they belong. With the browser extension, Work can use tabs you approve in Brave, Chrome, or Edge, with your existing sign-ins, while you keep working. You stay in control. Choose what Work can reach, follow its progress, review file changes, and restore a supported saved edit. And it feels right at home, with native menus, familiar shortcuts, and drag and drop from Finder. Now you know what Gab AI for Mac can do for your work."
    },
    {
      "slug": "mac-project-folders",
      "title": "Work in a folder on your Mac",
      "description": "Connect Work to a folder on your Mac, choose read-only or read and write access, run local checks in a code project, and review or restore changes.",
      "duration": 57.4,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/mac-project-folders/ba3291685bdc/mac-project-folders.mp4",
      "poster": "https://cdn.gab.ai/tutorials/mac-project-folders/e6f5ae453dec/mac-project-folders-poster.jpg",
      "captions": "/tutorials/captions/mac-project-folders.en.vtt",
      "learn": [],
      "docs": [
        "project-folders",
        "mac-local-work"
      ],
      "cta": {
        "start": 52.21,
        "label": "Download for Mac",
        "action": "link",
        "href": "/mac",
        "left": 40.07,
        "top": 54.58,
        "width": 19.87,
        "height": 8.89
      },
      "transcript": "In the Mac app, Work can use a real folder on your Mac, whether it holds documents or code. Start a new Work chat and open Project folder in the composer. Choose a saved folder, or pick another one. Check read-only if you only want research, or leave it unchecked so Work can save files. Then describe the files to use and where to save the result. The chat keeps its folder for every follow-up. For code, connect the repository. Pick or create a Git branch, and turn on local tests and builds for that folder in Settings. Work runs your installed checks and shows you the changes. Review each change, and restore a supported saved edit if you want the original back. Now you know how to give Work a folder, and keep control of it."
    },
    {
      "slug": "mac-browser-and-app-access",
      "title": "Let Work use your browser",
      "description": "Connect the Gab AI extension to the Mac app so Work can use approved tabs with your existing sign-ins, and set up Safari or other Mac apps.",
      "duration": 59.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/mac-browser-and-app-access/e181200efe8f/mac-browser-and-app-access.mp4",
      "poster": "https://cdn.gab.ai/tutorials/mac-browser-and-app-access/04455164638c/mac-browser-and-app-access-poster.jpg",
      "captions": "/tutorials/captions/mac-browser-and-app-access.en.vtt",
      "learn": [],
      "docs": [
        "mac-browser-access"
      ],
      "cta": {
        "start": 53.86,
        "label": "Download for Mac",
        "action": "link",
        "href": "/mac",
        "left": 40.07,
        "top": 54.58,
        "width": 19.87,
        "height": 8.89
      },
      "transcript": "On your Mac, Work can use your browser and supported apps to research and get things done, with your permission. For Brave, Chrome, or Microsoft Edge, connect the Gab AI extension. Work uses the tabs you approve, with your existing sign-ins, and you can keep using your other tabs. To set it up, open Settings, then Mac app, then Browser and app access. Choose Connect browser, follow the guide until it says Connected, then save. Each website asks for your approval. You can take over at any time, hand control back, or stop access. Safari and other supported Mac apps use Mac app control instead. It needs its own macOS permissions, and some actions need the window in front. Now you know how to let Work use your browser, on your terms."
    },
    {
      "slug": "remote-from-your-phone",
      "title": "Work on your Mac from your phone",
      "description": "Pair the Gab AI iOS or Android app with your Mac, then start or continue Work in shared project folders and review the changes from your phone.",
      "duration": 57.6,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/remote-from-your-phone/f9dd6519a7d5/remote-from-your-phone.mp4",
      "poster": "https://cdn.gab.ai/tutorials/remote-from-your-phone/d09daadd8105/remote-from-your-phone-poster.jpg",
      "captions": "/tutorials/captions/remote-from-your-phone.en.vtt",
      "learn": [],
      "docs": [
        "remote"
      ],
      "cta": {
        "start": 53.02,
        "label": "Download for Mac",
        "action": "link",
        "href": "/mac",
        "left": 40.07,
        "top": 54.58,
        "width": 19.87,
        "height": 8.89
      },
      "transcript": "Remote lets you start and continue Work in your Mac’s project folders from your iPhone or Android phone. Sign in to the same Gab AI account on your Mac and your phone. On the Mac, open Remote in the sidebar, review which folders to share, and select Enable Remote and pair a phone. Scan the QR code with your phone’s camera and connect to your Mac. When the verification codes match, select Codes match on the Mac to pair. Now open Remote on your phone. Start a new Work chat in a shared folder, or continue one you started on your Mac, and review the changes. Keep your Mac awake, online, and running Gab AI. You can share a folder read-only, and your phone and Mac can be on different networks. Now you know how to take your Mac projects with you."
    },
    {
      "slug": "first-five-minutes",
      "title": "Your first five minutes with Gab AI",
      "description": "A one-minute tour: the home screen, Chat and Work, Auto, your first prompt, follow-ups, and chat history.",
      "duration": 72.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/first-five-minutes/94b11f51b212/first-five-minutes.mp4",
      "poster": "https://cdn.gab.ai/tutorials/first-five-minutes/68eee39a9f7b/first-five-minutes-poster.jpg",
      "captions": "/tutorials/captions/first-five-minutes.en.vtt",
      "learn": [
        "first-prompt"
      ],
      "docs": [
        "index",
        "quickstart",
        "chat"
      ],
      "cta": {
        "start": 65.61,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Welcome to Gab AI! In the next minute, you'll send your first prompt and get a useful answer back. This is your home screen. Use Chat to ask questions and work through ideas. Switch to Work when you want Gab AI to carry out a bigger project and make files for you. Auto picks the right model for each message, so you can leave it on. If you ever want a specific model, you can choose one here. Now let's try a real task. Say what you want, add the details, and tell it the format. In a few seconds, you have a draft. Check it against what you asked for: the day, the time, the place, and the length. When it looks right, copy it with one click. Want a change? Just ask. Gab AI remembers the conversation, so you don't have to repeat yourself. Start a new chat for a new topic. Your past chats are saved on the left, so you can pick up right where you left off. That's all it takes. Now send your own first prompt in Gab AI."
    },
    {
      "slug": "better-prompts",
      "title": "Write a prompt that gets a useful answer",
      "description": "See how the same request goes from generic to useful when you add the task, the details, and the format.",
      "duration": 61.7,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/better-prompts/dd18c73ef83a/better-prompts.mp4",
      "poster": "https://cdn.gab.ai/tutorials/better-prompts/4098be2aa39b/better-prompts-poster.jpg",
      "captions": "/tutorials/captions/better-prompts.en.vtt",
      "learn": [
        "being-specific"
      ],
      "docs": [],
      "cta": {
        "start": 54.78,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Let's see why some prompts get great answers and others get generic ones. It usually comes down to three things. Here's a vague prompt: write a birthday message. Let's see what comes back. It's fine, but it's generic. Gab AI had to guess who it's for, what tone to use, and how long it should be. Now add the three ingredients. The task: a birthday message. The details: who it is for and what she loves. And the format: short, and a little funny. This one fits. It's short, it mentions hiking, and it actually sounds like something you'd send. Whenever you get a generic answer, ask yourself what Gab AI would need to know, and add it to your prompt. That's the whole trick: the task, the details, and the format. Now try it with your own prompt."
    },
    {
      "slug": "improve-the-answer",
      "title": "Improve the first answer",
      "description": "Ask for a change, regenerate for a fresh take, and keep going until the answer fits.",
      "duration": 47.8,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/improve-the-answer/b4bb1134007f/improve-the-answer.mp4",
      "poster": "https://cdn.gab.ai/tutorials/improve-the-answer/6769ffff6e7c/improve-the-answer-poster.jpg",
      "captions": "/tutorials/captions/improve-the-answer.en.vtt",
      "learn": [
        "iterating-prompts"
      ],
      "docs": [
        "chat"
      ],
      "cta": {
        "start": 41.91,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "The first answer is a starting point, not the final word. Here's how to shape it in a few seconds. Let's ask for three names for a neighborhood book club. Close, but not quite. Just say what to change. Make them shorter, and a little more playful. Want a different take on the same request? Select Regenerate. You can ask for more details, a more concise version, or just try again. Keep going until it fits. Each follow-up only takes a few seconds, and Gab AI remembers everything you asked for. Now you know how to shape any answer until it fits."
    },
    {
      "slug": "give-useful-context",
      "title": "Give Gab AI useful context",
      "description": "Paste the message you are replying to and the details of your situation, and see how the answer uses every one.",
      "duration": 46.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/give-useful-context/1bd8ad9f3630/give-useful-context.mp4",
      "poster": "https://cdn.gab.ai/tutorials/give-useful-context/888da04634a2/give-useful-context-poster.jpg",
      "captions": "/tutorials/captions/give-useful-context.en.vtt",
      "learn": [
        "providing-context"
      ],
      "docs": [],
      "cta": {
        "start": 40.39,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI can't see your inbox or your calendar. Context is the background you share so the answer fits your situation. Here, we paste the landlord's message, add our schedule, and say what we want: a short, friendly reply. Look how the reply uses every detail: the time window, your roommate Sam, and a visit before eleven, when he leaves. You can also add context by attaching a file or a screenshot, instead of typing everything out. The more Gab AI knows about your situation, the less it has to guess. Now you know how to give Gab AI the context it needs."
    },
    {
      "slug": "role-prompting",
      "title": "Give Gab AI a role",
      "description": "Start a prompt with a role, like a patient personal trainer, and see how it shapes the tone and the advice.",
      "duration": 41.5,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/role-prompting/50e41f2b382d/role-prompting.mp4",
      "poster": "https://cdn.gab.ai/tutorials/role-prompting/0ab2f254060d/role-prompting-poster.jpg",
      "captions": "/tutorials/captions/role-prompting.en.vtt",
      "learn": [
        "role-prompting"
      ],
      "docs": [],
      "cta": {
        "start": 35.6,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "One of the simplest ways to get a better answer is to tell Gab AI who it should be. Start with a role. You are a patient personal trainer who works with beginners. Then describe your situation and what you need. The role shapes the whole answer: an encouraging tone, gentle exercises, and simple explanations. Try roles like an editor, a tutor, or a travel planner, whenever you want a certain kind of expertise. Now you know how to use a role to shape any answer."
    },
    {
      "slug": "think-step-by-step",
      "title": "Ask Gab AI to think step by step",
      "description": "Ask Gab AI to work through a decision step by step, so you can check its reasoning before you accept the answer.",
      "duration": 42.6,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/think-step-by-step/67bea87bc81a/think-step-by-step.mp4",
      "poster": "https://cdn.gab.ai/tutorials/think-step-by-step/a2e14de6f962/think-step-by-step-poster.jpg",
      "captions": "/tutorials/captions/think-step-by-step.en.vtt",
      "learn": [
        "chain-of-thought"
      ],
      "docs": [],
      "cta": {
        "start": 36.72,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "For decisions and tricky problems, asking Gab AI to think step by step gives you an answer you can actually check. Here is a real decision: a cheaper car with more miles, or a pricier one with fewer. We ask it to work through the decision step by step before recommending one. Now you can see each step of the reasoning. If one step looks wrong, you can question it before you accept the recommendation. Use step by step for budgets, plans, comparisons, and math, anywhere you want to see how it got the answer. Now you know how to get reasoning you can check, not just an answer."
    },
    {
      "slug": "show-examples",
      "title": "Show Gab AI an example",
      "description": "Paste two examples of the style you want, and Gab AI matches their length, tone, and format for the next one.",
      "duration": 39.9,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/show-examples/948156cbe1e7/show-examples.mp4",
      "poster": "https://cdn.gab.ai/tutorials/show-examples/158f8f6e699c/show-examples-poster.jpg",
      "captions": "/tutorials/captions/show-examples.en.vtt",
      "learn": [
        "few-shot-examples"
      ],
      "docs": [],
      "cta": {
        "start": 33.97,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Describing a style is hard. Showing it is easy. Give Gab AI a couple of examples, and it follows them. Here we paste two short product descriptions we like, then ask for one more in the same style. It follows the same pattern as the examples: short, simple, and in the same format. Examples work great for emails, social posts, product listings, and anything with a format you want to repeat. Now you know how to get the exact style you want with a few examples."
    },
    {
      "slug": "models-and-credits",
      "title": "Models, Auto, and credits",
      "description": "How Auto picks a model, how to choose one yourself, and where to see your credits and usage.",
      "duration": 49.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/models-and-credits/b1e41bc4d147/models-and-credits.mp4",
      "poster": "https://cdn.gab.ai/tutorials/models-and-credits/60496bd77bbe/models-and-credits-poster.jpg",
      "captions": "/tutorials/captions/models-and-credits.en.vtt",
      "learn": [
        "how-gab-ai-works"
      ],
      "docs": [
        "models",
        "credits",
        "pricing-guide"
      ],
      "cta": {
        "start": 43.38,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI gives you many AI models in one place. Here's how Auto works, how to pick a model yourself, and how credits work. Every message starts on Auto. Gab AI looks at your request and picks a model that is good at that kind of task. To choose a model yourself, open the picker and search by name. Tap the star to save a model to your favorites. Everything you do uses credits from one balance. Your monthly credits reset each month, and credits you buy never expire. Usage History shows what each chat and creation cost, so there are no surprises. Now you know how to choose a model and keep an eye on your credits."
    },
    {
      "slug": "research-with-sources",
      "title": "Research with sources you can check",
      "description": "Use web search for current information, then check the cited sources before you rely on the answer.",
      "duration": 46,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/research-with-sources/2825a17035f8/research-with-sources.mp4",
      "poster": "https://cdn.gab.ai/tutorials/research-with-sources/782b0e751d2b/research-with-sources-poster.jpg",
      "captions": "/tutorials/captions/research-with-sources.en.vtt",
      "learn": [
        "research"
      ],
      "docs": [
        "web-search"
      ],
      "cta": {
        "start": 40.1,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "When you need current information, let Gab AI search the web, and then check the sources yourself. Open the plus menu and turn on Web search. Now ask a question about something current. Asking for sources makes the answer easy to verify. Gab AI searched the web and wrote a summary. The numbered citations show where each fact came from. The Sources panel lists every page used. Before you rely on a fact, open the source and check it yourself. Now you know how to research with sources you can check."
    },
    {
      "slug": "check-before-you-trust",
      "title": "Check before you trust",
      "description": "Ask for sources, check names, numbers, and dates against them, and ask Gab AI what you should double-check.",
      "duration": 51.1,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/check-before-you-trust/e755a4552453/check-before-you-trust.mp4",
      "poster": "https://cdn.gab.ai/tutorials/check-before-you-trust/3928de37da7e/check-before-you-trust-poster.jpg",
      "captions": "/tutorials/captions/check-before-you-trust.en.vtt",
      "learn": [
        "common-mistakes"
      ],
      "docs": [],
      "cta": {
        "start": 45.17,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "AI answers can sound confident and still be wrong. A quick check keeps mistakes out of your work. Ask your question, and ask for sources. With web search on, Gab AI shows where each fact came from. Names, numbers, and dates are where mistakes hide. Compare them with the sources listed on the right. You can also ask Gab AI what it is unsure about. It will tell you what is worth double-checking. For anything important, like health, money, or legal questions, confirm with the source or an expert before you act. Now you know how to check an answer before you rely on it."
    },
    {
      "slug": "upload-a-file",
      "title": "Upload a file and ask about it",
      "description": "Attach a PDF, ask for a summary and the key dates, then ask follow-up questions about the same file.",
      "duration": 50.4,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/upload-a-file/2a5f9badd675/upload-a-file.mp4",
      "poster": "https://cdn.gab.ai/tutorials/upload-a-file/902c545705d4/upload-a-file-poster.jpg",
      "captions": "/tutorials/captions/upload-a-file.en.vtt",
      "learn": [
        "file-uploads"
      ],
      "docs": [
        "files"
      ],
      "cta": {
        "start": 44.43,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI can read your documents. Attach a file, and ask questions about what is inside. Open the plus menu, choose Add photos and files, and pick your document. Here, it is a community garden plan. Ask for exactly what you need. Summarize the plan in three bullets, and list every deadline with its date. Gab AI read the whole file. The summary and every date come straight from the document. Keep asking about the same file. How much of the budget comes from plot fees? Now you know how to get answers from your own documents."
    },
    {
      "slug": "voice-mode",
      "title": "Talk it through with Voice Mode",
      "description": "Start Voice Mode, learn the controls for muting, voices, and ending the call, and find the conversation saved as a chat.",
      "duration": 45.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/voice-mode/8495578d091a/voice-mode.mp4",
      "poster": "https://cdn.gab.ai/tutorials/voice-mode/f4d50709de7a/voice-mode-poster.jpg",
      "captions": "/tutorials/captions/voice-mode.en.vtt",
      "learn": [
        "voice-and-search"
      ],
      "docs": [
        "voice"
      ],
      "cta": {
        "start": 39.36,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Sometimes it is easier to just talk. Voice Mode lets you have a spoken conversation with Gab AI. Select the Voice Mode button, right next to the message box. Just speak naturally. You can interrupt at any time, press Space to mute, and press Escape to end. Voice Mode uses credits by the minute. While you talk, these controls let you mute your microphone, choose a different voice, or end the call. When you end the call, the whole conversation is saved as a chat, so you can read it again later. Now you know how to have a spoken conversation with Gab AI."
    },
    {
      "slug": "custom-bots",
      "title": "Build a custom bot",
      "description": "Create a bot in a few steps: name it, approve its responsibilities and instructions, pick an avatar, and start chatting.",
      "duration": 61.9,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/custom-bots/50eb86286ddd/custom-bots.mp4",
      "poster": "https://cdn.gab.ai/tutorials/custom-bots/72027b0a7cfa/custom-bots-poster.jpg",
      "captions": "/tutorials/captions/custom-bots.en.vtt",
      "learn": [
        "custom-agents"
      ],
      "docs": [
        "agents"
      ],
      "cta": {
        "start": 55.99,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "A bot is a helper with its own job and instructions. You can build one in about a minute. Open Bots from the left side. You can use a ready-made bot, or create your own. Start with a name. We'll call this one Garden Planner. Gab AI suggests what your bot should do. Keep it, edit it, or write your own. Next, it writes the instructions your bot follows in every conversation. It even designs an avatar. When you like what you see, select Create bot. Now just chat. Your bot keeps its job and instructions every time you talk to it. Now you know how to build a bot for any job."
    },
    {
      "slug": "ai-memory",
      "title": "Teach Gab AI to remember you",
      "description": "Add a memory in Settings, see Gab AI use it in a new chat, and learn where to review or remove what it remembers.",
      "duration": 58.1,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/ai-memory/7611933e1a64/ai-memory.mp4",
      "poster": "https://cdn.gab.ai/tutorials/ai-memory/e6a3691276a0/ai-memory-poster.jpg",
      "captions": "/tutorials/captions/ai-memory.en.vtt",
      "learn": [
        "memory"
      ],
      "docs": [
        "memory"
      ],
      "cta": {
        "start": 52.21,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Tired of repeating yourself? Tell Gab AI something once, and it remembers it in every chat. Open Settings and choose Memory. This is where you can see what Gab AI remembers about you. Select Add a Memory, and write something that matters. I'm vegetarian, and I cook for a family of four on weeknights. Now start a new chat and ask for dinner ideas. Gab AI already knows, so every idea is vegetarian and sized for four. Gab AI also learns from your chats over time. You can review, edit, or delete any memory in Settings whenever you like. Now Gab AI can remember what matters to you."
    },
    {
      "slug": "collections-and-bookmarks",
      "title": "Organize with Collections and Bookmarks",
      "description": "Create a collection for a project, start chats inside it, and bookmark the answers you want to find again.",
      "duration": 51.5,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/collections-and-bookmarks/508a9da7cad0/collections-and-bookmarks.mp4",
      "poster": "https://cdn.gab.ai/tutorials/collections-and-bookmarks/8217fad9f7d3/collections-and-bookmarks-poster.jpg",
      "captions": "/tutorials/captions/collections-and-bookmarks.en.vtt",
      "learn": [
        "collections-org"
      ],
      "docs": [
        "collections",
        "bookmarks"
      ],
      "cta": {
        "start": 45.57,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "As your chats pile up, Collections and Bookmarks keep everything easy to find. A collection keeps related chats and files together. Select New collection, give it a name, and pick an icon. Any chat you start from here is saved in the collection automatically. To keep an answer handy, open its menu and choose Bookmark. Open the collection any time to find all of its chats and files in one place. Now you know how to keep your projects organized."
    },
    {
      "slug": "maps-and-cards",
      "title": "Plan with Maps and interactive answer cards",
      "description": "Explore a city in Maps, open a place for hours and a sourced guide, then plan an outing as an interactive card.",
      "duration": 47,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/maps-and-cards/9dc7c138cb72/maps-and-cards.mp4",
      "poster": "https://cdn.gab.ai/tutorials/maps-and-cards/444b280bb69d/maps-and-cards-poster.jpg",
      "captions": "/tutorials/captions/maps-and-cards.en.vtt",
      "learn": [],
      "docs": [
        "maps",
        "interactive-cards"
      ],
      "cta": {
        "start": 41.09,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI can help you find places and plan a day out. Let me show you Maps, and the interactive cards it creates. Open Maps from the left side, and choose a city. We will explore Asheville, North Carolina. Search for anything, or tap a category like Outdoors. Every place shows its rating and whether it is open right now. Open a place to see its hours, address, and a short guide with sources. Select Plan an outing, and Gab AI builds an itinerary as an interactive card you can check off as you go. Now you know how to find places and plan an outing with Gab AI."
    },
    {
      "slug": "automated-tasks",
      "title": "Schedule automated tasks",
      "description": "Create a task with instructions, choose when it runs, and get results delivered on schedule.",
      "duration": 61.8,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/automated-tasks/56fd157d0872/automated-tasks.mp4",
      "poster": "https://cdn.gab.ai/tutorials/automated-tasks/c281d1dd02cb/automated-tasks-poster.jpg",
      "captions": "/tutorials/captions/automated-tasks.en.vtt",
      "learn": [],
      "docs": [
        "tasks"
      ],
      "cta": {
        "start": 55.89,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Some questions you ask every day. Automated tasks let Gab AI do them for you, on a schedule. Open the More menu on the left, and choose Tasks. Start from a template, or create your own. Give the task a name, and write instructions just like a normal prompt. Choose when it runs. We will check every day at seven in the morning. You can also have results emailed to you. Review everything, and create the task. Your task now runs on its own. Find its results here in Tasks, and pause or edit it any time. Now Gab AI can take care of your daily questions for you."
    },
    {
      "slug": "write-with-ai",
      "title": "Turn rough notes into a clear email",
      "description": "Paste rough notes, name the reader and the tone, set a length, then ask Gab AI to adjust the draft until it sounds like you.",
      "duration": 48.4,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/write-with-ai/832b89735653/write-with-ai.mp4",
      "poster": "https://cdn.gab.ai/tutorials/write-with-ai/1aec2068ac8b/write-with-ai-poster.jpg",
      "captions": "/tutorials/captions/write-with-ai.en.vtt",
      "learn": [
        "writing-assistant"
      ],
      "docs": [],
      "cta": {
        "start": 42.46,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI is a great writing partner. You bring the facts and the tone, and it handles the wording. Start with your rough notes. Say who the reader is, the tone you want, and how long it should be. And ask it not to invent details. You get a short, clear draft with every fact from your notes. Read it the way your reader will. Then make it yours. Ask for a warmer opening, or a more casual tone, and the draft updates in seconds. Before you send it, check that every fact is right and that it still sounds like you. Now you know how to turn rough notes into a message that sounds like you."
    },
    {
      "slug": "code-help",
      "title": "Fix an error with Gab AI",
      "description": "Paste the code and the exact error, say what should happen, and ask Gab AI to explain the problem and show the fix.",
      "duration": 40.7,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/code-help/9518120a7e85/code-help.mp4",
      "poster": "https://cdn.gab.ai/tutorials/code-help/aa2c4bae11c3/code-help-poster.jpg",
      "captions": "/tutorials/captions/code-help.en.vtt",
      "learn": [
        "code-help"
      ],
      "docs": [],
      "cta": {
        "start": 34.73,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Code either works or it doesn't, so when you ask for help, precision matters. Here's what to include. Name the language, paste the code and the exact error, and say what it should do. Then ask for an explanation and the fix. You get a plain-English explanation of the error, and fixed code you can copy. Always run the fix yourself. If something still breaks, paste the new error and keep going. Now you know how to give Gab AI what it needs to fix your code."
    },
    {
      "slug": "text-to-image",
      "title": "Describe the image you need",
      "description": "Write an image prompt with a subject, a style, and a composition, then open the result in the image studio to review and edit it.",
      "duration": 53.1,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/text-to-image/95704f195b68/text-to-image.mp4",
      "poster": "https://cdn.gab.ai/tutorials/text-to-image/e3b157f7caa0/text-to-image-poster.jpg",
      "captions": "/tutorials/captions/text-to-image.en.vtt",
      "learn": [
        "text-to-image"
      ],
      "docs": [
        "images"
      ],
      "cta": {
        "start": 47.14,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "You can create images right in the chat. The more clearly you describe the picture, the closer the first result gets. Describe the subject, the style, and the layout. Here: a watercolor of neighbors planting a community garden, wide, with open sky on the left for a headline, and no text. The chat shows a preview. Open the image to see the whole thing, and check it against your prompt. The image studio lets you keep going. Edit part of the picture, remove something, resize it to a new shape, or make a variation. Change one thing at a time, so you can see exactly what each edit does. Now you know how to describe an image and refine it in the image studio."
    },
    {
      "slug": "image-to-video",
      "title": "Bring a still image to life",
      "description": "Attach a still image and write a motion prompt: what moves, how the camera moves, and how long the clip should be.",
      "duration": 59.8,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/image-to-video/0e822daf05b4/image-to-video.mp4",
      "poster": "https://cdn.gab.ai/tutorials/image-to-video/6ba60fe02a63/image-to-video-poster.jpg",
      "captions": "/tutorials/captions/image-to-video.en.vtt",
      "learn": [
        "image-to-video"
      ],
      "docs": [
        "videos"
      ],
      "cta": {
        "start": 53.92,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "You can turn any still image into a short video clip. All it takes is a picture and a motion prompt. Start by attaching your image. Here we use a watercolor of a community garden. Then describe the motion, not the picture. What moves, what the camera does, and how long it lasts. The image already shows what's in the scene. Video takes a little longer than text. Gab AI picks a video model and shows its progress while the clip renders. Here is the clip. Watch it through and check the motion against your prompt. If something is off, ask for one change at a time, like a slower camera or less movement. Now you know how to turn a still image into a moving clip."
    },
    {
      "slug": "text-to-video",
      "title": "Create a video from a description",
      "description": "Write a text-to-video prompt with a setting, one clear action, a camera move, and a length, then review the clip.",
      "duration": 55,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/text-to-video/ed26e21f6f98/text-to-video.mp4",
      "poster": "https://cdn.gab.ai/tutorials/text-to-video/56ce4331fdb3/text-to-video-poster.jpg",
      "captions": "/tutorials/captions/text-to-video.en.vtt",
      "learn": [
        "video-generation"
      ],
      "docs": [
        "videos"
      ],
      "cta": {
        "start": 49.06,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI can create a short video from nothing but a description. Think of your prompt as a tiny screenplay. Set the scene, give it one clear action, and say what the camera does. Here: a paper boat drifting down a rainy street at dusk, with a low camera following it. Video takes longer than text or images. You can watch its progress right in the chat. Here is the clip. Watch it through and compare it with your prompt: the setting, the action, and the camera. Keep it to one or two actions per clip. For a longer story, make several short clips and join them. Now you know how to write a video prompt that gets the shot you imagined."
    },
    {
      "slug": "music-generation",
      "title": "Create a song from a description",
      "description": "Write a music prompt with a genre, a mood and tempo, instruments, vocals or none, and a length, then listen to the track Gab AI composes.",
      "duration": 65.8,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/music-generation/353069df11ec/music-generation.mp4",
      "poster": "https://cdn.gab.ai/tutorials/music-generation/319ee288662d/music-generation-poster.jpg",
      "captions": "/tutorials/captions/music-generation.en.vtt",
      "learn": [
        "music-generation"
      ],
      "docs": [
        "music"
      ],
      "cta": {
        "start": 59.86,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Gab AI can compose original music from a written description. Describe a finished track, not just a vibe. Name the genre, the mood and tempo, the instruments, whether you want vocals, and how long it should be. Here: a thirty second lo-fi instrumental for a study video. Music takes a little longer than text. Gab AI picks a music model and composes the track. Press play and listen. Not quite right? Change one part of the prompt at a time, like the tempo or an instrument, and try again. Now you know how to describe the exact track you want."
    },
    {
      "slug": "meet-gab-ai-work",
      "title": "Meet Gab AI Work",
      "description": "Switch to Work, describe the outcome and the file you want, follow the progress, then open the finished artifact.",
      "duration": 55.5,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/meet-gab-ai-work/8aa81ee45b85/meet-gab-ai-work.mp4",
      "poster": "https://cdn.gab.ai/tutorials/meet-gab-ai-work/bb7d0c042a79/meet-gab-ai-work-poster.jpg",
      "captions": "/tutorials/captions/meet-gab-ai-work.en.vtt",
      "learn": [
        "agentic-workflows"
      ],
      "docs": [
        "work"
      ],
      "cta": {
        "start": 49.61,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Some tasks take more than one answer. Work plans them, uses tools, and delivers a finished file you can open and edit. Select Work above the composer. Describe the outcome, what to include, and the file you want. Here: a one-page project brief for a small browser game, delivered as an editable document. Work plans the task and shows each step as it goes. You can watch, answer questions if it asks, or come back later. When it finishes, open the document to review it. You can edit it directly, or ask for a change in the same task. Running Work uses credits, so start with a small, clear brief, and build from there. Now you know how to hand Work a project and review what it makes."
    },
    {
      "slug": "write-a-work-brief",
      "title": "Write a useful Work brief",
      "description": "Build a Work brief from four parts: the outcome, the audience and context, the output format, and a check that tells you it is done.",
      "duration": 57.7,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/write-a-work-brief/b1ae63d1e5be/write-a-work-brief.mp4",
      "poster": "https://cdn.gab.ai/tutorials/write-a-work-brief/502361eebc6a/write-a-work-brief-poster.jpg",
      "captions": "/tutorials/captions/write-a-work-brief.en.vtt",
      "learn": [
        "briefing-agents"
      ],
      "docs": [
        "work-prompts"
      ],
      "cta": {
        "start": 51.83,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "The better your brief, the better the result. A useful Work brief answers four questions. What do you want? Who is it for? What format should it be in? And how will you know it is done? Here, the outcome is a quick-start card. The audience is new players, age ten and up. The format is an editable, one-page document. And the check: it fits one page, and the controls match the brief. Work follows the brief and delivers the document. Open it and review it against your brief, one point at a time. Because you wrote down the check, you know exactly what to look for. Short and specific beats long and vague. Leave out anything that does not change the result. Now you know how to write a brief that Work can finish, and you can check."
    },
    {
      "slug": "artifact-toolkit",
      "title": "Your artifact toolkit",
      "description": "Tour the files Work makes: documents, spreadsheets, presentations, images, and code. Each opens in its own editor and exports to the format you need.",
      "duration": 52.4,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/artifact-toolkit/8654886f4973/artifact-toolkit.mp4",
      "poster": "https://cdn.gab.ai/tutorials/artifact-toolkit/47e4b27a56ea/artifact-toolkit-poster.jpg",
      "captions": "/tutorials/captions/artifact-toolkit.en.vtt",
      "learn": [
        "agent-tools"
      ],
      "docs": [
        "work-files"
      ],
      "cta": {
        "start": 46.52,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Choose the result before the tool. Tell Work which kind of file you want, and it picks the right tools to make it. Everything Work makes is saved in Files: documents, images, presentations, code, and more. Documents open in a real editor. Change the text and tables, use AI to rewrite a part, then export to Word or PDF. Spreadsheets keep their formulas and export to Excel. Presentations have slides and speaker notes, and export to PowerPoint or PDF. Code and web pages run right in the preview. Ask for the editable file as well as the final download, so you can keep refining it. Now you know which file to ask for, and how to take it with you."
    },
    {
      "slug": "review-and-revise-work",
      "title": "Review, revise, and finish",
      "description": "Review a first version against your brief, ask Work for one specific revision in the same task, and say what must stay the same.",
      "duration": 59.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/review-and-revise-work/b296343021d1/review-and-revise-work.mp4",
      "poster": "https://cdn.gab.ai/tutorials/review-and-revise-work/a90ab8387f98/review-and-revise-work-poster.jpg",
      "captions": "/tutorials/captions/review-and-revise-work.en.vtt",
      "learn": [
        "running-agent-loops"
      ],
      "docs": [
        "work-artifacts"
      ],
      "cta": {
        "start": 53.34,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "The first version is a starting point. A short, focused feedback loop gets you to a finished result. Start with a useful first version. Here we ask Work for a simple release checklist. Open it and find the most important thing to change. Here, the list would be easier to use in groups. Ask for that one change in the same task, and say what must stay the same. Work updates the existing file instead of starting over. Open the new version and check the change, and that nothing else broke. When it is right, export the file you will actually use. Now you know how to steer Work from a first draft to a finished file."
    },
    {
      "slug": "work-game",
      "title": "Build a playable browser game",
      "description": "Give Work a clear game brief, then play the finished game right in the code artifact and ask for changes.",
      "duration": 50.9,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/work-game/eb7247a834bd/work-game.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-game/60b5e9df7220/work-game-poster.jpg",
      "captions": "/tutorials/captions/work-game.en.vtt",
      "learn": [
        "work-games"
      ],
      "docs": [
        "work-games"
      ],
      "cta": {
        "start": 45,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "With Work, you can build a small game that runs in your browser, without writing any code yourself. Switch to Work, then describe the game: how you move, how you win or lose, the look, and what to test. Work writes the game, runs it, and checks it against your list. This takes a few minutes, so we sped it up. Open the game to play it right here. Try the controls, collect a few stars, and make sure restart works. If something is off, describe what you saw and what you expected, and Work updates the same game. Now you know how to brief Work on a game and test what it builds."
    },
    {
      "slug": "work-image",
      "title": "Create and edit an image in Work",
      "description": "Brief Work on a game cover with a subject, style, and layout, then open the image artifact to edit a region, remove details, or change its shape.",
      "duration": 47.7,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/work-image/620f6b375419/work-image.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-image/e3d04bb8eb07/work-image-poster.jpg",
      "captions": "/tutorials/captions/work-image.en.vtt",
      "learn": [
        "work-images"
      ],
      "docs": [
        "work-images"
      ],
      "cta": {
        "start": 41.78,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Work can create an image as a file you keep refining, not just a picture in the chat. In Work, describe the subject, the style, the shape, and any space you need. Here: a square game cover with room at the top for a title. Work writes the image prompt, picks a model, and delivers the image as a file. Open the image to review it up close. From here, you can select an area to change, remove a distraction, or resize it for a new format. Send one focused edit at a time, and compare it with the original before you download. Now you know how to create an image in Work and refine it step by step."
    },
    {
      "slug": "work-document",
      "title": "Make an editable document",
      "description": "Brief Work on a player guide with an audience and sections, open the editable document, make a direct edit, and export to Word or PDF.",
      "duration": 54.2,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/work-document/eefbf92aa6c7/work-document.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-document/afc61285aefe/work-document-poster.jpg",
      "captions": "/tutorials/captions/work-document.en.vtt",
      "learn": [
        "work-documents"
      ],
      "docs": [
        "work-documents",
        "editors"
      ],
      "cta": {
        "start": 47.34,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Work can write a real, formatted document that you edit like any other, and export when you are ready. In Work, name the audience, the sections, and the format. Here: a two-page player guide for first-time players. Work drafts the guide and saves it as a document. Open the document. It is a real editor, so you can change the text, headings, and tables yourself, and your edits are saved. When it is ready, use Export to download a Word file or a PDF, and open it to check the layout. For bigger changes, ask Work in the same task, and name what should stay the same. Now you know how to turn a brief into a document you can edit and share."
    },
    {
      "slug": "work-spreadsheet",
      "title": "Build a working spreadsheet",
      "description": "Brief Work on a launch budget with formulas, open the editable workbook, and check the totals against a result you already know.",
      "duration": 50.6,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/work-spreadsheet/9447d7683769/work-spreadsheet.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-spreadsheet/19f258e557e9/work-spreadsheet-poster.jpg",
      "captions": "/tutorials/captions/work-spreadsheet.en.vtt",
      "learn": [
        "work-spreadsheets"
      ],
      "docs": [
        "work-spreadsheets"
      ],
      "cta": {
        "start": 44.65,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Work can build a real spreadsheet with formulas you can check and edit, not just a table in the chat. In Work, list the columns and rows, and ask for formulas. Here: a small launch budget. Art, music, and testing. Work builds the workbook, adds the formulas, and saves it as a file. Open the spreadsheet and check it with numbers you know. Two times seventy-five, plus one twenty, plus four times twenty-five, should total three hundred seventy. Change an input cell and watch the totals update. If a formula looks wrong, ask Work to fix that cell. Now you know how to build a spreadsheet in Work and check that its math is right."
    },
    {
      "slug": "work-presentation",
      "title": "Create a presentation",
      "description": "Brief Work on a five-slide pitch with an audience and colors, open the editable deck, and step through the slides and speaker notes.",
      "duration": 52.6,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/work-presentation/be90fb28705b/work-presentation.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-presentation/c9e66b80396b/work-presentation-poster.jpg",
      "captions": "/tutorials/captions/work-presentation.en.vtt",
      "learn": [
        "work-presentations"
      ],
      "docs": [
        "work-presentations"
      ],
      "cta": {
        "start": 46.64,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Work can turn your outline into an editable slide deck, with speaker notes, ready to present. In Work, list the slides, the audience, and the look. Here: a five-slide pitch in midnight blue, white, and gold. Work writes the slides and the speaker notes, and saves the deck as a file. Open the deck and step through it. Each slide should make one clear point. Edit any slide or its notes directly, rehearse with Present, and export to PowerPoint or PDF when you are done. Now you know how to brief Work on a deck and make it your own."
    },
    {
      "slug": "work-video",
      "title": "Make a video, step by step",
      "description": "Brief Work on a three-shot teaser with a consistent style, answer its questions and approvals, then watch the preview before the final export.",
      "duration": 67.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/work-video/a5be6c9e5661/work-video.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-video/404ef9de8267/work-video-poster.jpg",
      "captions": "/tutorials/captions/work-video.en.vtt",
      "learn": [
        "work-videos"
      ],
      "docs": [
        "work-videos"
      ],
      "cta": {
        "start": 61.42,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Work can plan and produce a short video from several shots, and put them together into one finished clip. In Work, plan the story as a few short shots. Describe each one, and keep the style and character the same across all of them. If Work asks a question, like whether to add narration, answer it and it keeps going. Then it creates reference images, generates each clip, and edits them together. We sped this part up. Before the final export, Work shows you a preview of the whole video. Watch it all the way through, with sound, then approve it or ask for a change. To change a shot, name it and describe the change. Work regenerates just that clip, and keeps the rest. Now you know how to plan a video with Work and review it shot by shot."
    },
    {
      "slug": "export-and-import-your-data",
      "title": "Download your data and import chats",
      "description": "Download a ZIP of your Gab AI account data from Settings, and import conversations from Gab AI, ChatGPT, Claude, or Grok.",
      "duration": 47.8,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/export-and-import-your-data/0b0245e0c3d5/export-and-import-your-data.mp4",
      "poster": "https://cdn.gab.ai/tutorials/export-and-import-your-data/0aa443be9cdc/export-and-import-your-data-poster.jpg",
      "captions": "/tutorials/captions/export-and-import-your-data.en.vtt",
      "learn": [],
      "docs": [
        "data-export",
        "import-chats"
      ],
      "cta": {
        "start": 41.89,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Your data belongs to you. You can download all of it, or bring your chat history from another AI service. Open Settings, then General. Select Download ZIP to get an archive of your chats, memories, files, and more. Every conversation comes as a readable file, along with everything else tied to your account. To bring chats in, open Import. Choose the service you are moving from, follow its export steps, then select Import and choose the file. Importing does not use any credits, and your imported chats show up next to your regular ones. Now you know how to take your data with you, and bring your chats along."
    },
    {
      "slug": "ai-tools",
      "title": "Use a ready-made AI tool",
      "description": "Open Tools, choose a tool like the Logo Generator, fill in its form or try an example, and generate a result.",
      "duration": 77.3,
      "uploadDate": "2026-09-27",
      "src": "https://cdn.gab.ai/tutorials/ai-tools/6c48c51835c6/ai-tools.mp4",
      "poster": "https://cdn.gab.ai/tutorials/ai-tools/3166485f3430/ai-tools-poster.jpg",
      "captions": "/tutorials/captions/ai-tools.en.vtt",
      "learn": [],
      "docs": [
        "tools"
      ],
      "cta": {
        "start": 71.36,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "Tools are ready-made AI workflows. Instead of writing a prompt, you fill in a short form. Open Tools in the sidebar. They are grouped by what you want to do: create, edit, or write. Pick a tool. Here, the Logo Generator. Fill in the form, or select Try an example to see how it works. Then generate. The tool turns your answers into a detailed prompt and picks the right model. Review the result. You can adjust the form and run it again, or find it later in Recent runs. Now you know how to get a great result from a tool in a few clicks."
    },
    {
      "slug": "work-video-editor",
      "title": "The Work video studio, step by step",
      "description": "Follow a full Work video project: approve the storyboard, improve a reference image, generate and redo clips, approve the music, and download the finished video.",
      "duration": 240.9,
      "uploadDate": "2026-09-28",
      "src": "https://cdn.gab.ai/tutorials/work-video-editor/bd3150a15c7f/work-video-editor.mp4",
      "poster": "https://cdn.gab.ai/tutorials/work-video-editor/12fd154d4f43/work-video-editor-poster.jpg",
      "captions": "/tutorials/captions/work-video-editor.en.vtt",
      "learn": [
        "work-video-editor"
      ],
      "docs": [],
      "cta": {
        "start": 235.02,
        "label": "Open Gab AI",
        "action": "app",
        "left": 41.92,
        "top": 54.58,
        "width": 16.16,
        "height": 8.89
      },
      "transcript": "This lesson walks through the whole video studio in Work, from the first script to the finished file. Switch to Work and describe your video: how long it is, the shots you want, the style, and the music. Ask Work to show you a storyboard first, and to wait for your approval before it makes anything. Work writes a shot-by-shot storyboard, lists the images it needs, and estimates the credits. Nothing has been generated yet. If the script looks right, choose Approve script. Or choose Change script and say what to fix. Work then creates a reference image of your character, and a starting image for every shot. The video studio opens next to the chat. Step one is Reference media. Characters holds the look that keeps your astronaut consistent, and Scenes holds the starting image for each shot. To fix an image, select it and choose Improve this image. Describe the change in everyday words, or tap a suggestion, then choose Create new version. Your original is kept. The new take appears under Versions. Switch between takes to compare them, then choose Use this image to keep the one you like. When every image looks right, choose Approve images and create clips. Work shows the credit cost before it spends anything. Approve it to start the clips. Step two is Clips. Each shot becomes a short video clip. We sped up the wait. Select each shot in the timeline to watch it. You can drag clips to reorder them, or exclude a shot from the final video. To redo a clip, choose Improve this shot, describe what should change, and create a new version. Work regenerates only that shot. Compare the takes and pick the one to use in the film. The green label shows which take goes into the final video. Now choose Create final video. Work combines the clips into a preview, and writes music to go with it. Step three is Final video. Watch the preview, then approve the visuals, or describe a change. Next, approve the music. You can also ask for different music, skip it, or upload your own. Work mixes in the music and saves each export as a new version. Approve the preview, and Work assembles the finished video. Want a tweak? Describe it under Make changes. Every revision is saved as a new version, so earlier ones stay available. When it looks right, choose Download video to save the file. Now you can take a video from script to final file in the Work video studio."
    }
  ]
}
